import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { endProcessing, startProcessing } from '../../../actions/loadingAction';
import { BackButton, Input, RadioButton, Select, Collapsible, Button, SelectDock } from '../../../components/UI/ComponentsUI';
import AreaService from '../../../services/AreaService';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { getVision } from '../../../services/auth';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { configs, convertToUppercase, getPreAllocationArea, groupBy, isNullOrEmpty, showMessageToast, showMessageToastCustom, translate } from '../../../utils/util';

const MassiveReceipt = (props) => {
    let auxAlternative = 0;
    const almox = props.location.state.almox;
    const baiFilter = props.location.state.baiFilter;
    const faasa = (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD);
    const [visualMassiveReceipts, setVisualMassiveReceipts] = useState([])
    const [receiptsBai, setReceiptsBai] = useState([])
    const [massiveReceipts, setmassiveReceipts] = useState([])
    const [massiveCimPallet, setMassiveCimPallet] = useState([])
    const [config, setConfig] = useState({});
    const [model, setModel] = useState({
        place: "1",
        mdrBai: configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items).mdrBaiCode || '',
        preAllocation: undefined,
        preAllocationArea: props.filter?.truckKanban ? 'XD%' : getPreAllocationArea(getVision()),
        print: (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) ? ENUMS.ePrintTypes.Click.value : props.printSelect,
    });

    useEffect(() => {
        setConfig(configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items));

        if (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            props.setPrintSelect(ENUMS.ePrintTypes.Click.value)
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const dataItem = props.receipts;
        let arrayBai = [];
        if (dataItem && dataItem.length > 0) {
            let massiveReceipts = dataItem.filter((item) => item.massiveReceiptIndicator);
            if (!isNullOrEmpty(almox)) {
                massiveReceipts = massiveReceipts.filter((item) => item.almox === almox);
            }

            if (!isNullOrEmpty(baiFilter)) {
                massiveReceipts = massiveReceipts.filter((item) => item.baiCode === baiFilter);
            }
            setmassiveReceipts([...massiveReceipts]);
            arrayBai.push(...massiveReceipts);

            let visualReceipts = dataItem.filter((item) => item.visualReceiptIndicator);
            if (!isNullOrEmpty(almox)) {
                visualReceipts = visualReceipts.filter((item) => item.almox === almox);
            }

            if (!isNullOrEmpty(baiFilter)) {
                visualReceipts = visualReceipts.filter((item) => item.baiCode === baiFilter);
            }
            setVisualMassiveReceipts([...visualReceipts]);
            arrayBai.push(...visualReceipts);
        }

        if (props.receiptsCimPallet && props.receiptsCimPallet.length > 0) {
            var receiptsCimPalletArray = props.receiptsCimPallet;
            setMassiveCimPallet([...receiptsCimPalletArray]);
            arrayBai.push(...receiptsCimPalletArray);
        }

        validateGroupedBai(arrayBai)

        // eslint-disable-next-line
    }, [props?.receipts]);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const validateGroupedBai = (values) => {
        var grouped = groupBy(values.filter((f) => !isNullOrEmpty(f.baiCode)), "baiCode");
        if (grouped.find((map) => map.value.length > 1)) {

            let arrayReceipt = [];
            grouped.forEach((element) => {
                arrayReceipt.push(...element.value)
            })

            setReceiptsBai(arrayReceipt);
            return true;
        }

        return false;
    }

    const onChangeDateMassive = (receipt, event) => {
        const receiptsUpdates = [];
        Object.assign(receiptsUpdates, massiveReceipts);
        const receiptUpdate = receiptsUpdates.find((i) => { return i.id === receipt.id; });
        if (receiptUpdate !== undefined) {
            if (receiptUpdate.perishable === 'P') {
                receiptUpdate.productionDate = event.target.value;
            }
            if (receiptUpdate.perishable === 'V') {
                receiptUpdate.expirationDate = event.target.value;
            }
        }

        setVisualMassiveReceipts(receiptsUpdates);
    };

    const onChangeDateVisual = (receipt, event) => {
        const receiptsUpdates = [];
        Object.assign(receiptsUpdates, visualMassiveReceipts);
        const receiptUpdate = receiptsUpdates.find((i) => { return i.id === receipt.id; });
        if (receiptUpdate !== undefined) {
            if (receiptUpdate.perishable === 'P') {
                receiptUpdate.productionDate = event.target.value;
            }
            if (receiptUpdate.perishable === 'V') {
                receiptUpdate.expirationDate = event.target.value;
            }
        }

        setmassiveReceipts(receiptsUpdates);
    };

    const onChangeDateCimpallet = (receipt, event) => {
        const receiptsUpdates = [];
        Object.assign(receiptsUpdates, massiveCimPallet);
        const receiptUpdate = receiptsUpdates.find((i) => { return i.id === receipt.id; });
        if (receiptUpdate !== undefined) {
            if (receiptUpdate.perishable === 'P') {
                receiptUpdate.productionDate = event.target.value;
            }
            if (receiptUpdate.perishable === 'V') {
                receiptUpdate.expirationDate = event.target.value;
            }
        }

        setMassiveCimPallet(receiptsUpdates);
    };

    const onChangeMdrMassive = (receipt, event) => {
        const receiptsUpdates = [];
        Object.assign(receiptsUpdates, massiveReceipts);
        const receiptUpdate = receiptsUpdates.find((i) => { return i.id === receipt.id; });
        if (receiptUpdate !== undefined) {
            receiptUpdate.mdrInput = event.target.value;
        }

        setmassiveReceipts(receiptsUpdates);
    };

    const onChangeMdrVisual = (receipt, event) => {
        const receiptsUpdates = [];
        Object.assign(receiptsUpdates, visualMassiveReceipts);
        const receiptUpdate = receiptsUpdates.find((i) => { return i.id === receipt.id; });
        if (receiptUpdate !== undefined) {
            receiptUpdate.mdrInput = event.target.value;
        }

        setVisualMassiveReceipts(receiptsUpdates);
    };

    const onChangeMdrCimpallet = (receipt, event) => {
        const receiptsUpdates = [];
        Object.assign(receiptsUpdates, massiveCimPallet);
        const receiptUpdate = receiptsUpdates.find((i) => { return i.id === receipt.id; });
        if (receiptUpdate) {
            receiptUpdate.mdrInput = event.target.value;
        }
        setMassiveCimPallet(receiptsUpdates);
    };

    const isValidSubmit = () => {
        var union = [...new Set([...massiveCimPallet, ...visualMassiveReceipts, ...massiveReceipts])];

        var findRequiredDate = union.find((item) =>
            (item.perishable === 'P' && !item.productionDate) ||
            (item.perishable === 'V' && !item.expirationDate)
        )

        if (findRequiredDate !== undefined) {
            showMessageToast({ html: translate('date-required', 'physical-confirmation'), classes: 'red' });
            return false;
        }

        if (model.print === ENUMS.ePrintTypes.Click.value && ((onChangeResource() ?? "") === "")) {
            showMessageToastCustom(translate('warning', 'general'), translate('missing-click-resource-name', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }
        if (union.find(f => isNullOrEmpty(f.mdrInput) && isNullOrEmpty(f.mdr))) {
            showMessageToastCustom(translate('warning', 'general'), "Existem Desenhos sem MDR, favor preencher.", 3000, 'mdi mdi-alert-circle-outline red-text');
            validateInputsRequired("validadeMdr");
            return false;
        }

        return true;
    };

    const calcBalance = (value) => {
        if (value.balance) {
            if (isNullOrEmpty(value.baiCode)) {
                return value.balance / (value.qme > 0 ? value.qme : 1)
            } else {
                return 1;
            }
        }

        return "";
    }

    const calcBalanceItems = (value) => {
        if (isNullOrEmpty(value.baiCode)) {
            return value.qme > 0 ? value.qme : 1
        } else {
            return value.balance
        }
    }

    const onChangeResource = () => {
        try {
            if (!isNullOrEmpty(props.user.resource)) {
                const resource = props.resources.find((i) => i.resourceId === parseInt(props.user.resource));
                return model.print === ENUMS.ePrintTypes.Click.value && !isNullOrEmpty(resource.clickResourceName) ? resource.clickResourceName : resource.name;
            }
            return "";
        } catch (error) {
            console.log(error);
            return "";
        }
    }

    const searchBaiItem = (item, itemBai) => {
        if (receiptsBai.length > 0) {
            var itemUpdate = receiptsBai.find((f) => f.id === item.id);

            if (itemUpdate) {
                if (!isNullOrEmpty(itemUpdate.mdrNewBai)) {
                    return itemUpdate.mdrNewBai
                } else if (!isNullOrEmpty(model.mdrBai)) {
                    return model.mdrBai
                }
            }
            return itemBai ? model.mdrBai : (isNullOrEmpty(item.mdr) ? item.mdrInput : item.mdr);

        }
        return isNullOrEmpty(item.mdr) ? item.mdrInput : item.mdr;
    }

    const callbackSearch = () => {
        var shed = !Boolean(config.shedRequiredPhysicalConfirmation) || props.filter?.truckKanban ? "" : props.sheds.find((i) => i.id === props.user.shed).code;

        props.resetReceipsCimPallet();
        if (getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD && (!isNullOrEmpty(props.physicalConfirmation?.mvmNumber) || !isNullOrEmpty(props.physicalConfirmation?.journey || props.receiptIds.length > 0))) {
            let filterDto = {
                mvmNumber: props.filter.mvmNumber,
                journey: props.filter.journey,
                supplier: props.filter.supplier,
                invoice: props.filter.invoice,
                truckKanban: props.filter?.truckKanban,
                shed: shed,
                dock: !props.filter?.truckKanban ? props.user.dock : '',
                pending: true,
                receiptIds: props.receiptIds
            }
            props.showLoading("Atualizando...");
            props.search(filterDto, () => {
                props.hideLoading();
            });
        } else {
            props.hideLoading();
        }
        props.history.go(-1);
    }

    const getConfig = () => {
        return configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items)
    }

    const createdMassive = (itemsMassive, itemsCimPallet, itemsVisualMassive, multipleJourneyCimPallet) => {
        var shed = !Boolean(getConfig()?.shedRequiredPhysicalConfirmation) || props.filter?.truckKanban ? "" : props.sheds.find((i) => i.id === props.user.shed).code;
        var dock = !Boolean(getConfig()?.dockRequiredPhysicalConfirmation) || props.filter?.truckKanban ? "M01" : props.user.dock;

        if (model.place === "2") {
            model.preAllocation = props.filter?.truckKanban ? "S" : "N";
            model.preAllocationArea = dock;
        } else {
            model.preAllocation = "S";
        }

        let listDto = []
        itemsMassive.forEach(r => {
            let dto = {
                id: r.id,
                mdrBai: searchBaiItem(r, true),
                printer: props.user.printer,
                resource: onChangeResource(),
                preAllocationArea: props.filter?.truckKanban ? "XD%" : model.preAllocationArea,
                preAllocation: model.preAllocation,
                print: model.print,
                productionDate: r.productionDate,
                expirationDate: r.expirationDate,
                dock: dock,
                shed: shed,
                mdr: searchBaiItem(r, false),
                cimPallet: false,
                mvi: props.filter?.mvi,
                truckKanban: props.filter?.truckKanban,
                boxQuantity: parseInt(calcBalance(r)),
                boxQuantityItems: calcBalanceItems(r)
            };
            listDto.push(dto);
        });

        itemsVisualMassive.forEach(r => {
            let dto = {
                id: r.id,
                mdrBai: searchBaiItem(r, true),
                printer: props.user.printer,
                resource: onChangeResource(),
                preAllocationArea: props.filter?.truckKanban ? "XD%" : model.preAllocationArea,
                preAllocation: model.preAllocation,
                print: model.print,
                productionDate: r.productionDate,
                expirationDate: r.expirationDate,
                dock: dock,
                shed: shed,
                mdr: searchBaiItem(r, false),
                cimPallet: false,
                mvi: props.filter?.mvi,
                truckKanban: props.filter?.truckKanban,
                boxQuantity: 1,
                boxQuantityItems: r.balance
            };
            listDto.push(dto);
        });

        itemsCimPallet.forEach(r => {
            listDto.push({
                id: r.id,
                mdrBai: searchBaiItem(r, true),
                resource: onChangeResource(),
                printer: props.user.printer,
                preAllocationArea: props.filter?.truckKanban ? "XD%" : model.preAllocationArea,
                preAllocation: model.preAllocation,
                print: model.print,
                productionDate: r.productionDate,
                expirationDate: r.expirationDate,
                dock: dock,
                shed: shed,
                remainingBalance: r.remainingBalance,
                cimPallet: parseInt(r.qtStorage) > 1 ? true : (r.remainingBalance ? true : false),
                mdr: searchBaiItem(r, false),
                mvi: props.filter?.mvi,
                truckKanban: props.filter?.truckKanban,
                boxQuantity: parseInt(r.qtStorage),
                boxQuantityItems: r.qme > 0 ? parseInt(r.qme) : 1
            })
        });

        props.sendMassive({
            listDto,
            alternativeMDRAreas: config.alternativeMDRAreas,
            truckKanban: props.filter?.truckKanban
        }, (data) => {
            if (!multipleJourneyCimPallet) {
                sendAlternativeChangeLocation(data)
            }
        });
    }

    const submit = () => {
        try {
            if (isValidSubmit()) {
                var multipleJourneyCimPallet = groupBy(massiveCimPallet, "journey");
                if (multipleJourneyCimPallet.length > 1) {
                    for (let index = 0; index < multipleJourneyCimPallet.length; index += 1) {
                        const element = multipleJourneyCimPallet[index].value;
                        if (index === 0) {
                            createdMassive(massiveReceipts, element, visualMassiveReceipts, index !== multipleJourneyCimPallet.length - 1);
                        } else {
                            createdMassive([], element, [], index !== multipleJourneyCimPallet.length - 1);
                        }
                    }
                } else {
                    createdMassive(massiveReceipts, massiveCimPallet, visualMassiveReceipts, false);
                }
            }
        } catch (error) {
            props.hideLoading();
            showMessageToast({ html: error.message || error, classes: 'red' });
        }
    }

    const sendAlternativeChangeLocation = (data) => {
        if (!props.filter?.truckKanban && data) {
            props.showLoading("Enviando Mdr Alternativo Locação...")
            data.forEach(element => {
                const dataSend = {
                    print: model.print,
                    resource: onChangeResource(),
                    printer: props.user?.printer,
                    idLabel: element.id
                };
                props.alternativeChangeLocation(dataSend, () => {
                    auxAlternative = auxAlternative + 1;
                    if (auxAlternative === data.length) {
                        props.hideLoading();
                        callbackSearch();
                    }
                })
            });
        } else {
            callbackSearch();
        }
    }

    const changeMdrBaiItem = (key, newBai) => {
        receiptsBai.filter((f) => f.baiCode === key).forEach((element) => {
            element.mdrNewBai = newBai;
        })

        setReceiptsBai([...receiptsBai])
    }

    const renderBaiMassive = () => {
        var grouped = groupBy(receiptsBai.filter((f) => !isNullOrEmpty(f.baiCode)), "baiCode");
        if (grouped.find((map) => map.value.length > 1)) {

            return grouped.map((item) => (
                <Collapsible
                    key={`${item.key}`}
                    close="true"
                    header={`BAI - ${item.key}`}
                    body={
                        <>
                            <Input
                                label="MDR BAI"
                                id={`mdrBai-${item.key}`}
                                name={`mdrBai-${item.key}`}
                                type="text"
                                onChange={(evt) => changeMdrBaiItem(item.key, evt.target.value)}
                            />
                            {
                                item.value.map((itemValue, index) => (
                                    <div key={`${itemValue.partNumberCode}-${index}`} style={{ marginBottom: '20px' }}>
                                        <p style={{ marginBottom: '-7px' }}>
                                            {`${itemValue.partNumberDescription}  ${itemValue.partNumberCode} MDR-${itemValue.mdr}${(!isNullOrEmpty(itemValue.mdrNewBai) ? (`(${itemValue.mdrNewBai})`) : "")}`}</p>
                                    </div>
                                )
                                )
                            }
                        </>

                    }
                />));
        }

        return <></>;
    }

    const orderReceiptsByMdr = (receiptData) => {
        const arrayFilter = receiptData.sort((a, b) => {
            if (a.mdr < b.mdr) { return -1; }
            if (a.mdr > b.mdr) { return 1; }
            return 0;
        });

        return arrayFilter;
    }

    const renderMassive = () => {
        const arrayFilter = orderReceiptsByMdr(receiptsBai.length > 0 ? massiveReceipts.filter((f) => isNullOrEmpty(f.baiCode)) : massiveReceipts);

        return (
            arrayFilter.map((item, index) => (
                <div key={`massiveItem-${index}`} style={{ marginBottom: '20px' }}>
                    <p key={`p-massiveItem-${index}`} style={{ marginBottom: '-7px' }}>
                        {`${item.partNumberDescription}  ${item.partNumberCode} MDR-${item.mdr} (MASSIVO)`}</p>
                    {
                        item.perishable !== 'N' &&
                        <Input
                            type="date"
                            label={item.perishable === 'P' ? translate('production-date', 'physical-confirmation') : translate('expiration-date', 'physical-confirmation')}
                            id={item.perishable === 'P' ? 'productionDate' : 'expirationDate'}
                            name={item.perishable === 'P' ? 'productionDate' : 'expirationDate'}
                            onChange={(e) => {
                                onChangeDateMassive(item, e);
                            }}
                            required
                            className="sixth-text-color"
                        />
                    }
                    {
                        isNullOrEmpty(item.mdr) &&
                        <div className='row'>
                            <div className="input-field no-padding col s5">
                                <Input
                                    type="text"
                                    label="MDR"
                                    id="mdrInputMassive"
                                    name="mdrInputMassive"
                                    onChange={(e) => {
                                        onChangeMdrMassive(item, e);
                                    }}
                                    required
                                    defaultValue={item.mdrInput}
                                />
                            </div>
                        </div>
                    }
                </div>
            ))
        )
    }

    return (
        <div>
            <BackButton id="backMassive" {...props} />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                        {
                            !props.filter?.truckKanban && <>
                                <RadioButton
                                    name='place'
                                    onChange={(e) => onChange(e)}
                                    defaultChecked={model.place}
                                    label={translate('select-storage-area', 'physical-confirmation')}
                                    items={[
                                        { id: "1", label: translate('storage', 'physical-confirmation') },
                                        { id: "2", label: translate('entrance-area', 'physical-confirmation') },
                                    ]}
                                />
                                {
                                    getVision() === VISIONS.Jeep && model.place === "2" &&
                                    <SelectDock
                                        required
                                        unload="true"
                                        id="preAllocationArea"
                                        name="preAllocationArea"
                                        filterArea
                                        shedId={props.user.shed}
                                        value={props.user.dock}
                                        onChange={onChange}
                                    />
                                }
                                {
                                    getVision() !== VISIONS.Jeep && model.place === "2" &&
                                    <Input
                                        required
                                        id="preAllocationArea"
                                        name="preAllocationArea"
                                        defaultValue={faasa ? "M01" : props.user.dock}
                                        disabled
                                        onKeyUp={convertToUppercase}
                                    />
                                }
                                {model.place === "1" &&
                                    <div className="input-field no-padding col s12" style={{ marginTop: '20px' }}>
                                        <Input
                                            disabled={props.filter?.truckKanban}
                                            required={model.place === 1}
                                            label={translate('pre-allocation-area', 'physical-confirmation')}
                                            id="preAllocationArea"
                                            name="preAllocationArea"
                                            type="text"
                                            defaultValue={model.preAllocationArea || ""}
                                            onChange={onChange}
                                            onKeyUp={convertToUppercase}
                                        />
                                    </div>
                                }
                                <div className="input-field">
                                    <Select
                                        required
                                        id="print"
                                        name="print"
                                        display="name"
                                        label={translate('print-type', 'physical-confirmation')}
                                        placeHolder={translate('choose-one-option', 'general')}
                                        data={[
                                            { id: ENUMS.ePrintTypes.Logistics.value, text: translate(ENUMS.ePrintTypes.Logistics.text, 'physical-confirmation') },
                                            { id: ENUMS.ePrintTypes.Click.value, text: translate(ENUMS.ePrintTypes.Click.text, 'physical-confirmation') },
                                            { id: ENUMS.ePrintTypes.NotPrint.value, text: translate(ENUMS.ePrintTypes.NotPrint.text, 'physical-confirmation') },
                                        ]}
                                        change={(e) => {
                                            props.setPrintSelect(e.target.value);
                                            onChange(e);
                                        }}
                                        defaultValue={model.print}
                                    />
                                </div>
                            </>
                        }
                        {receiptsBai.length > 0 &&
                            <div className="input-field no-padding col s12" style={{ marginTop: '20px' }}>
                                <Input
                                    required={model.place === 1}
                                    label="MDR Bai"
                                    id="mdrBai"
                                    name="mdrBai"
                                    type="text"
                                    defaultValue={model.mdrBai}
                                    onChange={onChange}
                                    onKeyUp={convertToUppercase}
                                />
                            </div>
                        }

                        <div style={{ marginTop: '10px' }}>
                            {receiptsBai.length > 0 && renderBaiMassive()}
                            <div id="validadeMdr">
                                {renderMassive()}
                                {orderReceiptsByMdr(massiveCimPallet).map((item, index) => (
                                    <div key={index} style={{ marginBottom: '20px' }}>
                                        <p style={{ marginBottom: '-7px' }}>
                                            {`${item.partNumberDescription}  ${item.partNumberCode} MDR-${item.mdr} (CIM PALLET)`}</p>
                                        {
                                            item.perishable !== 'N' &&
                                            <Input
                                                type="date"
                                                label={item.perishable === 'P' ? translate('production-date', 'physical-confirmation') : translate('expiration-date', 'physical-confirmation')}
                                                id={item.perishable === 'P' ? 'productionDate' : 'expirationDate'}
                                                name={item.perishable === 'P' ? 'productionDate' : 'expirationDate'}
                                                onChange={(e) => {
                                                    onChangeDateCimpallet(item, e);
                                                }}
                                                required
                                                className="sixth-text-color"
                                            />
                                        }
                                        {
                                            isNullOrEmpty(item.mdr) &&
                                            <div className='row'>
                                                <div className="input-field no-padding col s5">
                                                    <Input
                                                        type="text"
                                                        label="MDR"
                                                        id="mdrInputCimpallet"
                                                        name="mdrInputCimpallet"
                                                        onChange={(e) => {
                                                            onChangeMdrCimpallet(item, e);
                                                        }}
                                                        required
                                                        defaultValue={item.mdrInput}
                                                    />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                ))}
                                {orderReceiptsByMdr(visualMassiveReceipts).map((item, index) => (
                                    <div key={index} style={{ marginBottom: '20px' }}>
                                        <p style={{ marginBottom: '-7px' }}>
                                            {`${item.partNumberDescription}  ${item.partNumberCode} MDR-${item.mdr} (VISUAL)`}</p>
                                        {
                                            item.perishable !== 'N' &&
                                            <Input
                                                type="date"
                                                label={item.perishable === 'P' ? translate('production-date', 'physical-confirmation') : translate('expiration-date', 'physical-confirmation')}
                                                id={item.perishable === 'P' ? 'productionDate' : 'expirationDate'}
                                                name={item.perishable === 'P' ? 'productionDate' : 'expirationDate'}
                                                onChange={(e) => {
                                                    onChangeDateVisual(item, e);
                                                }}
                                                required
                                                className="sixth-text-color"
                                            />
                                        }
                                        {
                                            isNullOrEmpty(item.mdr) &&
                                            <div className='row'>
                                                <div className="input-field no-padding col s5">
                                                    <Input
                                                        type="text"
                                                        label="MDR"
                                                        id="mdrInputVisual"
                                                        name="mdrInputVisual"
                                                        onChange={(e) => {
                                                            onChangeMdrVisual(item, e);
                                                        }}
                                                        defaultValue={item.mdrInput}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="row" style={{ margin: '10px 0 15px 0' }}>
                            <div className="col s12">
                                <Button onClick={() => submit()} full="true" text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        receipts: state.physicalConfirmationReducer.receipts,
        areas: state.areaReducer.areas,
        user: state.userReducer.user,
        config: state.configReducer.config,
        sheds: state.configReducer.sheds,
        resources: state.logisticsResourceReducer.list,
        printLabel: state.physicalConfirmationReducer.printLabel,
        receiptsCimPallet: state.physicalConfirmationReducer.receiptsCimPallet,
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,
        printSelect: state.physicalConfirmationReducer.printSelect,
        receiptIds: state.physicalConfirmationReducer.receiptIds,
        filter: state.physicalConfirmationReducer.filter,
        physicalConfirmationList: state.physicalConfirmationReducer.physicalConfirmationList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAreas: (vision, filter, pagination) => {
            dispatch(AreaService.getAreas(vision, filter, pagination));
        },
        showLoading: (message) => {
            dispatch(startProcessing(message));
        },
        hideLoading: () => {
            dispatch(endProcessing());
        },
        sendMassive: (item, callback) => {
            dispatch(PhysicalConfirmationService.insertConfirmationMassive(item, callback));
        },
        alternativeChangeLocation: (item, callback) => {
            dispatch(PhysicalConfirmationService.alternativeChangeLocation(item, callback));
        },
        resetReceipsCimPallet: () => {
            dispatch(PhysicalConfirmationService.resetReceipsCimPallet());
        },
        search: (filter, callback) => {
            dispatch(PhysicalConfirmationService.search(filter, callback));
        },
        setPrintSelect: (printSelect) => {
            dispatch(PhysicalConfirmationService.setPrintSelect(printSelect));
        },
        searchList: (filter, callback) => {
            dispatch(PhysicalConfirmationService.searchList(filter, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MassiveReceipt));